import { useState, useRef, useEffect } from 'react';
import { LuLoaderCircle } from 'react-icons/lu';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import classNames from '@/lib/misc/classNames';
interface Props {
  disabled?: boolean;
  text?: string;
  hasError?: string;
  onConfirm: () => void;
  swapLoading: boolean;
}
const SwipeToConfirm = (p: Props) => {
  const [position, setPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const containerRef = useRef(null);
  const startXRef = useRef(0);
  const getBackgroundColor = () => {
    const progress = position / (containerRef.current?.offsetWidth - 70) || 0;
    const startColor = {
      r: 255,
      g: 200,
      b: 222
    }; // #ffc8de
    const endColor = {
      r: 255,
      g: 163,
      b: 200
    }; // #FFA3C8

    const r = Math.round(startColor.r + (endColor.r - startColor.r) * progress);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * progress);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * progress);
    return `rgb(${r}, ${g}, ${b})`;
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    startXRef.current = e.touches[0].clientX - position;
    setIsDragging(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging) return;
    const newPosition = Math.max(0, Math.min(e.touches[0].clientX - startXRef.current, containerRef.current.offsetWidth - 70));
    setPosition(newPosition);
  };
  const handleTouchEnd = () => {
    const maxPosition = containerRef.current.offsetWidth - 80;
    if (position >= maxPosition) {
      setIsConfirmed(true);
      p.onConfirm();
    } else {
      setPosition(0);
    }
    setIsDragging(false);
  };
  function resetSlider() {
    setPosition(0);
    setIsConfirmed(false);
  }
  useEffect(() => {
    if (!p.swapLoading) {
      resetSlider();
    }
  }, [p.swapLoading]);
  if (isConfirmed && !p.hasError) {
    return <div className='w-full h-14 flex items-center justify-center bg-genius-pink border border-genius-blue rounded-full text-white'>
        <LuLoaderCircle size={26} className='animate-spin text-genius-blue' />
      </div>;
  }
  return <div ref={containerRef} className={`relative w-full h-14 bg-genius-indigo border border-genius-blue rounded-full overflow-hidden transition-opacity ${p.disabled ? 'opacity-50 pointer-events-none' : ''}`} data-sentry-component="SwipeToConfirm" data-sentry-source-file="SwipeConfirm.tsx">
      {/* Background overlay */}
      <div className='absolute inset-0 animate-shine' />

      {/* Progress bar */}
      <div className='absolute h-full' style={{
      width: `${position + 32}px`,
      backgroundColor: getBackgroundColor()
    }} />

      {/* Text with mask */}
      {p.text ? <div key={p.text} className={classNames('absolute inset-0 flex items-center justify-center text-genius-cream font-medium text-center leading-[120%] opacity-0 transition-opacity motion-safe:animate-[fadeIn_0.25s_ease-in_forwards]', p.hasError ? 'text-red-400' : '', p.text.length > 35 ? 'text-[12px]' : p.text.length > 25 ? 'text-[14px]' : 'text-[16px]')} style={{
      clipPath: `inset(0 0 0 ${position + 32}px)`,
      padding: '0 70px'
    }}>
          {p.text}
        </div> : null}

      {/* Circle */}
      <div className='absolute left-0 top-0 h-full w-[70px] rounded-full flex justify-center items-center bg-genius-pink' style={{
      transform: `translateX(${position}px)`
    }} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
        <MdKeyboardDoubleArrowRight size={28} className='text-genius-blue' data-sentry-element="MdKeyboardDoubleArrowRight" data-sentry-source-file="SwipeConfirm.tsx" />
      </div>
    </div>;
};
export default SwipeToConfirm;